import React from 'react';
import ReactDOM from 'react-dom/client';
import { globalStyles } from './globalStyles';
import { App } from './App';
import Projects from './routes/projects'
import Experience from './routes/experience'
import Skills from './routes/skills'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      {globalStyles}
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<App/>}>
            <Route path='projects' element={<Projects/>}/>
            <Route path='experience' element={<Experience/>}/>
            <Route path='skills' element={<Skills/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
  </React.StrictMode>
);
